import { useEffect, useState } from "react";

//* Components
import CareerPlusWebSliderSection from "../../components/pages/Index/CareerPlusWebSliderSection";
import SlideBannerSection from "../../components/pages/Index/SlideBannerSection";
import FooterSection from "../../components/pages/Index/FooterSection";
import ApplicationForm from "../../components/pages/Application/ApplicationForm";
import Loading from "../../components/pages/Index/Loading";

const Application = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section style={{ paddingTop: "95px" }}>
      <Loading />
      <CareerPlusWebSliderSection />
      <ApplicationForm />
      <SlideBannerSection />
      <FooterSection />
    </section>
  );
};
export default Application;
